import * as React from 'react';
import {
    SalesforceOpportunityCancelStateProps, SalesforceOpportunityCancelDispatchProps
} from '../../../types/mx/containers';

class SalesforceOpportunityCancelConfirmView
    extends React.Component<SalesforceOpportunityCancelStateProps & SalesforceOpportunityCancelDispatchProps, {}> {

    renderDetail() {
        return <React.Fragment>
            <p>
                Estas a punto de cancelar la oportunidad en Salesforce.
            </p>
        </React.Fragment>;
    }

    renderButton(onPressCancelConfirm, onPressClose) {
        return <React.Fragment><a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
                       onClick={onPressClose}>Cancelar</a>
            <a className="h-auto btn btn-link border-0 btn-form text-warning py-0 pr-0"
               onClick={onPressCancelConfirm}>Aceptar</a></React.Fragment>;
    }

    render() {
        const {onPressCancelConfirm, onPressClose} = this.props;
        return (
            <div className="col-12 p-0">
                <div className="text-justify">
                    {this.renderDetail()}
                </div>
                <div className="pt-3 px-0 text-right border-top">
                    {this.renderButton(onPressCancelConfirm, onPressClose)}
                </div>
            </div>
        );
    }
}

export default SalesforceOpportunityCancelConfirmView;